import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
export default class Option {
  constructor() {
    _defineProperty(this, "optionName", {
      fieldName: 'option_name',
      content: null
    });
    _defineProperty(this, "discount", {
      fieldName: 'discount',
      content: null
    });
    _defineProperty(this, "quantity", {
      fieldName: 'quantity',
      content: 1
    });
    _defineProperty(this, "salePrice", {
      fieldName: 'sale_price',
      content: 1
    });
    _defineProperty(this, "normalPrice", {
      fieldName: 'normal_price',
      content: 1
    });
  }
  static getOptionTypes() {
    return [Option.UPSELL, Option.CROSS_SELL];
  }
  getOptionName() {
    return this.optionName.content;
  }
  getDiscount() {
    return this.discount.content;
  }
  getQuantity() {
    return this.quantity.content;
  }
  getSalePrice() {
    return this.salePrice.content;
  }
  getNormalPrice() {
    return this.normalPrice.content;
  }
}
_defineProperty(Option, "UPSELL", 'upsell');
_defineProperty(Option, "CROSS_SELL", 'cross-sell');
_defineProperty(Option, "NORMAL_OFFER_TYPE", 'normal');
_defineProperty(Option, "WARNING_OFFER_TYPE", 'warranty');
_defineProperty(Option, "DISCOUNT_PATTERN", /({{dis}})?({{up}})?/g);